import "./Cliente.css";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { FaDownload } from "react-icons/fa6";


const Cliente = ({ slug, colorPrimario, colorSecundario }) => {
  console.log("📌 Slug recibido en Cliente:", slug);

  // 🔽 TODAS LAS URLs SEGÚN ENTORNO
  const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:3000";
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

  // 🔽 URLs DIRECTAS DE LOS ICONOS
  const llamarIcon = "https://tudcard.com/img/icono_llamar.png";
  const emailIcon = "https://tudcard.com/img/redes-sociales.png";
  const whatsappIcon = "https://tudcard.com/img/productos-ok.png";
  const descargaContact = "https://tudcard.com/img/descarga-ok.png";
  const compartirIcon = "https://tudcard.com/img/compartir.png";
  const compartir2Icon = "https://tudcard.com/img/whatsapp.png";
  const avatarDefault = "https://tudcard.com/img/avatar-default.png";
  const iconoDefault = "https://tudcard.com/img/icono-default.png";

  const [persona, setPersona] = useState(null);
  const [empresa, setEmpresa] = useState(null);
  const [error, setError] = useState(null);
  const [mostrarQR, setMostrarQR] = useState(false);

  const qrRef = useRef(null);

  const getApiUrl = (endpoint) => {
    const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
    return `${apiBaseUrl}${path}`;
  };

  const handleWhatsAppShare = () => {
    if (!empresa) return;
    const message = `Hola somos ${empresa.razon_social}. Te comparto nuestra tarjeta digital ${baseUrl}/#/cliente/${slug}/perfil`;
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, "_blank");
  };

  const toggleQR = () => setMostrarQR((prev) => !prev);

  useEffect(() => {
    if (mostrarQR && qrRef.current) {
      qrRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [mostrarQR]);

  useEffect(() => {
    const obtenerPerfil = async () => {
      try {
        if (!slug) return;
        const response = await axios.get(getApiUrl(`/personas/${slug}`));
        if (!response.data.persona || !response.data.empresa) {
          throw new Error("No se encontraron datos para este perfil");
        }
        setPersona(response.data.persona);
        setEmpresa(response.data.empresa);
      } catch (err) {
        console.error("❌ Error al obtener perfil:", err);
        setError(err.message || "Error desconocido");
      }
    };
    obtenerPerfil();
  }, [slug]);

  // 🔥 NUEVA FUNCIÓN: DESCARGAR CONTACTO DINÁMICO (VCF)
  const descargarVcf = () => {
    if (!persona || !empresa) return;

    // Formatear dirección para el estándar VCard
    const direccionVCard = `;;${empresa.direccion || ""};Marinilla;Antioquia;;Colombia`;

    const vcardContent = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `FN:${persona.nombre || ""}`,
      `ORG:${empresa.razon_social || ""}`,
      `TITLE:${persona.cargo || ""}`,
      `TEL;TYPE=CELL:${persona.celular || ""}`,
      `EMAIL;TYPE=INTERNET:${persona.correo_electronico || ""}`,
      `URL:${persona.link_pagina_web || ""}`,
      `ADR;TYPE=WORK:${direccionVCard}`,
      "END:VCARD"
    ].join("\r\n");

    const blob = new Blob([vcardContent], { type: "text/vcard;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${persona.nombre || 'contacto'}.vcf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // 🔥 NUEVA FUNCIÓN: DESCARGAR EL QR TAL CUAL VIENE DE LA BASE DE DATOS
  // Se descarga como Blob (en vez de solo enlazar la URL) porque link_qr
  // normalmente vive en otro dominio/CDN, y el atributo `download` de un
  // <a> no fuerza la descarga en recursos cross-origin — el navegador
  // simplemente abriría la imagen. Trayendo el archivo con fetch() y
  // generando un Blob local sí garantiza la descarga real en el
  // dispositivo, sin alterar la imagen original.
  const descargarQR = async () => {
    if (!empresa?.link_qr) return;

    try {
      const response = await fetch(empresa.link_qr, { mode: "cors" });
      if (!response.ok) throw new Error("No se pudo descargar el QR");

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      // Conserva la extensión real del archivo (png, jpg, webp...) si se
      // puede detectar en la URL; si no, usa png por defecto.
      const extMatch = empresa.link_qr.match(/\.(png|jpe?g|webp|svg)(\?|#|$)/i);
      const extension = extMatch ? extMatch[1] : "png";
      const nombreArchivo = `QR-${(empresa.razon_social || "d-card").replace(/\s+/g, "-")}.${extension}`;

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", nombreArchivo);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("❌ Error al descargar el QR:", err);
      // Respaldo: si falla el fetch (ej. por CORS), al menos abre la
      // imagen en una pestaña nueva para que el usuario pueda guardarla
      // manualmente en vez de quedarse sin ninguna opción.
      window.open(empresa.link_qr, "_blank");
    }
  };

  if (!persona || !empresa) return null;

  const { nombre, cargo, celular, correo_electronico, link_whatsapp, link_foto } = persona;
  const { link_qr } = empresa;

  return (
    <div className="cliente-card">
      {/* HEADER */}
      <div className="cliente-header" style={{ backgroundColor: colorPrimario }}>
        <h2 className="subtitulo-inferior marquee" style={{ color: colorSecundario }}>
          ¡Con D-Card, tus ventas CRECEN!
        </h2>
        <img
          src={link_foto}
          alt={nombre}
          className="cliente-foto"
          style={{ border: `4px solid ${colorSecundario}` }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = avatarDefault;
          }}
        />
      </div>

      {/* INFO */}
      <div className="cliente-info">
        <h4 style={{ color: colorPrimario }}>{nombre}</h4>
        <h5><strong>{cargo}</strong></h5>

        <div className="social-links">
          {/* Llamar */}
          <a href={`tel:${celular}`}>
            <div className="social-icon-box">
              <img src={llamarIcon} alt="Llamar" className="iphone" />
              <span className="icon-label"><strong>Llamar</strong></span>
            </div>
          </a>

          {/* Compartir WhatsApp (antes estaba en la posición de Correo) */}
          <div className="social-icon-box" onClick={handleWhatsAppShare} style={{ cursor: "pointer" }}>
            <img src={compartir2Icon} alt="Compartir" className="iphone" />
            <span className="icon-label"><strong>WhatsApp</strong></span>
          </div>

          {/* WhatsApp (Productos) */}
          {/* 🔻 Comentado: función original de WhatsApp, este botón ahora redirige a Productos */}
          {/* <a href={link_whatsapp} target="_blank" rel="noopener noreferrer"> */}
          <a href={`/cliente/${slug}/productos`}>
            <div className="social-icon-box">
              <img src={whatsappIcon} alt="Productos" className="iphone" />
              <span className="icon-label"><strong>Productos</strong></span>
            </div>
          </a>

          {/* 🔥 BOTÓN DESCARGAR CONTACTO (Actualizado a función JS) */}
          <div className="social-icon-box" onClick={descargarVcf} style={{ cursor: "pointer" }}>
            <img
              src={descargaContact}
              alt="Contacto"
              className="iphone"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = iconoDefault;
              }}
            />
            <span className="icon-label"><strong>Contacto</strong></span>
          </div>

          {/* Redes Sociales (antes Correo) */}
          {/* 🔻 Comentado: función original de mailto, este botón ahora redirige a Contacto */}
          {/* <a href={`mailto:${correo_electronico}`}> */}
          <a href={`/cliente/${slug}/contacto`}>
            <div className="social-icon-box">
              <img src={emailIcon} alt="Correo" className="iphone" />
              <span className="icon-label"><strong>Redes Sociales</strong></span>
            </div>
          </a>

          {/* Compartir QR */}
          <div className="social-icon-box" onClick={toggleQR} style={{ cursor: "pointer" }}>
            <img src={compartirIcon} alt="QR" className="iphone" />
            <span className="icon-label"><strong>Escanear QR</strong></span>
          </div>
        </div>
      </div>

      {/* SECCIÓN QR */}
      {mostrarQR && (
        <section className="seccion-codigo-qr" ref={qrRef}>
          <div className="cliente-inf">
            <div className="social-redes">
              <div className="cuadrado-con-borde-int">
                <div className="borde-interno-rojo" style={{ border: `3px solid ${colorPrimario}` }}>
                  <img
                    src={link_qr}
                    alt="QR de contacto"
                    className="tarjeta-qr-imagen"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = iconoDefault;
                    }}
                  />
                </div>
              </div>
            </div>

            {/* 🔥 NUEVO: BOTÓN DESCARGAR QR */}
            <button
              type="button"
              className="qr-download-button"
              style={{ backgroundColor: colorPrimario }}
              onClick={descargarQR}
            >
              <span className="qr-download-button__icon">
                <FaDownload />
              </span>
              <span className="qr-download-button__text">Descargar QR</span>
            </button>
            <p className="qr-download-caption">
              Escanea o haz clic para descargar
            </p>
          </div>
        </section>
      )}
    </div>
  );
};

export default Cliente;